
const contents = "query HomeNetworkRedirect($resourceId: ID) {\n  viewer {\n    homeNetworkRedirect(resourceId: $resourceId) {\n      networkPermalink\n      redirectResourceId\n      shouldRedirectToHomeNetwork\n    }\n  }\n}\n";
const sha256Hash = "71789a1dbdd4058965c4ca1f4d0b0770cd24ad594050ec4000f64fab46d610a6";
export default { contents: contents, sha256Hash: sha256Hash };
